export const isAudibel = (siteId: number) => {
    return siteId === 2;
};
